import { effect, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from './core/user.service';
import { Global } from './core/Global';

@Injectable()

export class PolicyService {
	private url: string;
	private entity: any


	constructor(
		private _http: HttpClient,
		private _userService: UserService,
	) {
		this.url = Global.url_seguros;
		this.entity = this._userService.sharingEntity()

	}

	getByCampus(campus: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		//Hacer peticion ajax
		return this._http.get(this.url + 'policies/campus/' + campus, { headers: headers })

	}

	getByYear(year: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		//Hacer peticion ajax
		return this._http.get(this.url + 'policies/year/' + year, { headers: headers })

	}

	getPolicyTransfer(entity: any, policy: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'policies/transfer/' + entity + '/' + policy, { headers: headers })
	}

	save(policy: any, collection?: any): Observable<any> {
		let params = { policy, collection };
		//definir las cabeceras
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		//Hacer peticion ajax
		return this._http.post(this.url + 'new-policy', params, { headers: headers })
	}
	openPeriod(year: any): Observable<any> {
		let params = { year: year };
		//definir las cabeceras
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		//Hacer peticion ajax
		return this._http.post(this.url + 'open-period', params, { headers: headers })
	}
	update(policy: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json')

		return this._http.patch(this.url + 'policies', policy, { headers: headers })
	}

	getContractedPolicies(insured: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json')
		return this._http.get(this.url + 'contracts/active-policies/' + insured, { headers: headers })
	}
	getCollection(id: any): Observable<any> {
		
		//Hacer peticion ajax
		return this._http.get(this.url + 'collections/' + id)

	}

	getCoverages(): Observable<any> {
		return this._http.get(this.url + 'coverages')
	}

	getPolicyOffice(_id?: string): Observable<any> {
		let campus = _id
		if (!campus) campus = "0"
		let headers = new HttpHeaders().set('Content-Type', 'application/json')

		return this._http.get(this.url + 'policies-office/' + campus, { headers: headers })
	}

	getFamily(policy: any): Observable<any> {
		const params = { policy: policy.policy._id, insured: policy.insured._id, fecval: policy.fecval, holder: policy.holder._id }
		let headers = new HttpHeaders().set('Content-Type', 'application/json')
		return this._http.get(this.url + 'list-family', { headers: headers, params: params })
	}

	transferInsured(policy: any, transfer: any): Observable<any> {
		const params = { policy: policy.policy._id, insured: policy.insured.rut, fecval: policy.fecval, transfer: transfer, holder: policy.holder }
		let headers = new HttpHeaders().set('Content-Type', 'application/json')
		return this._http.patch(this.url + 'transfer-insured', params, { headers: headers })
	}

}
